import { environments } from '@/environment';
import { BootService } from '@/services/boot';

/**
 * Options accepted by the backoffice portal's Extra Payout tool.
 *
 * `action=create` opens the creation form directly; `productId` prefills it for
 * a given item.
 */
type ExtraPayoutOptions = {
  action?: 'create';
  productId?: string | number;
};

/**
 * Resolve an absolute URL to the backoffice portal's Extra Payout tool for the
 * current environment.
 *
 * c360 is served from its own host (`c360.backoffice[.staging].*`), so links to
 * other backoffice tools must be absolute: a relative `/extra-payout` would
 * resolve against the c360 origin and 404.
 *
 * `hideheader=1` hides the portal chrome since we open the tool in a new tab,
 * and `rowsPerPage=50` matches the page size agents expect.
 */
export function getExtraPayoutUrl({ action, productId }: ExtraPayoutOptions = {}): string {
  const url = new URL(environments[BootService.env].extraPayoutUrl);

  url.searchParams.set('hideheader', '1');
  url.searchParams.set('rowsPerPage', '50');

  if (action) {
    url.searchParams.set('action', action);
  }
  if (productId !== undefined && productId !== null) {
    url.searchParams.set('productId', String(productId));
  }

  return url.toString();
}
